import React from 'react';
import './TypingIndicator.css';

/**
 * TypingIndicator - Animated dots indicator similar to iMessage/WhatsApp
 * Shows when the AI is thinking/preparing an answer
 * Uses <p> tag for bubble to match existing ConversationComponent styling
 */
const TypingIndicator = () => {
  return (
    <div className="conversation-item assistant">
      <p className="bubble speech assistant typing-indicator">
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
      </p>
    </div>
  );
};

export default TypingIndicator;
